<template>
  <div :class="containerClass" class="p-4 pl-6 mt-2 rounded shadow-md text-lg relative">
    <div class="flex items-center w-10 absolute top-1 right-1">
      <button class="pr-2 flex hover:text-b2c-red-300" :class="editClass" @click="$emit('edit', address)" aria-label="edit">
        <edit-icon />
      </button>
      <button class="hover:text-b2c-red-300" @click="$emit('delete', address.id)" v-if="!checkout" aria-label="delete">
        <bin-icon />
      </button>
    </div>
    <div class="flex justify-between">
      <div class="flex justify-start">
        <h2 v-if="title">{{ title }}</h2>
      </div>
      <div class="flex justify-end">

      </div>

    </div>
    <div>
      <div class="flex flex-col">
        <span class="font-bold">
          {{ address.company }}
        </span>
        <span class="font-semibold text-xs" v-show="address.co">
          c/o {{ address.co }}
        </span>
    </div>
    <div class="flex flex-wrap flex-col md:flex-row">
      <span :class="fontHairline()" class="md:pr-2">
        {{ address.address1 }}
      </span>
      <span class="hidden md:block pr-2">-</span>
      <span :class="fontHairline()" class="md:pr-2">
        {{ address.postcode }} {{ address.city }} ({{ address.state }})
      </span>
      <span class="hidden md:block pr-2">-</span>
      <span :class="fontHairline()">
        {{ address.country }}
      </span>
    </div>

    </div>

  </div>

</template>

<script>
import BinIcon from '@/components/graphics/BinIcon.vue';
import EditIcon from '@/components/graphics/EditIcon.vue';

export default {

  props: ['address', 'title', 'checkout', 'givenClass'],

  data() {
    return {
      containerClass: this.givenClass ? this.givenClass : '',

      editWidth: this.checkout ? '50%' : '100%',
      editClass: this.checkout ? 'justify-end' : '',
    };
  },

  components: {
    BinIcon,
    EditIcon,
  },

  computed: {
    isShippingAddress() {
      return this.address.type === 'S';
    },
  },

};
</script>
